// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"HY-z","sponsoredTooltipWrapper":"IY-z","sponsoredTooltip":"JY-z","newCard":"KY-z"};